import { render, staticRenderFns } from "./base.popover.vue?vue&type=template&id=32abeb8a&scoped=true"
import script from "./base.popover.vue?vue&type=script&lang=js"
export * from "./base.popover.vue?vue&type=script&lang=js"
import style0 from "./base.popover.vue?vue&type=style&index=0&id=32abeb8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32abeb8a",
  null
  
)

export default component.exports